import { FC } from "react"

export type AboutTabProps = {
  /**
   * Calculated response data to display to the user
   */
  // responseData: any
}

export const AboutTab: FC<AboutTabProps> = () => {
  return (
    <div className="flex flex-col items-start justify-center space-y-6 py-6 mx-auto max-w-sm w-full">
      <h1 className="w-full max-w-xs text-left text-black text-3xl font-semibold">
        About the Coherent Expected Losses Calculator App
      </h1>
      <a
        href="https://coherent.global/"
        target="_blank"
        rel="noreferrer"
        className="bg-brand-light text-white px-3 rounded h-10 leading-10"
      >
        LEARN MORE
      </a>
      <p>
        Coherent Spark instantly converts Excel into APIs so you can control, connect and comply across business logic.
        This app demonstrates just one example out of thousands of potential use cases. It is based on an Expected
        Credit Losses model using over 15,000 formulas, all converted into code in seconds by Coherent Spark.
      </p>
      <img src="./excel-example-file.png" alt="Expected Losses Calculator Excel" />
      <p>
        Coherent Spark is a no-code SaaS platform that “API-ifies” Excel models for faster system integrations, product
        innovation, and return on investment in minutes, not months.
      </p>
      <p>
        Our business partner, <span className="text-brand-light">Agilno</span>, used Spark out of the box to create this
        complete app, including workflows and complex logic modelling in just 27 hours including scoping, coding,
        multiple review rounds, quality controls. A production-ready app in days, not weeks, not months. (And the actual
        models themselves can be converted in seconds, or just minutes for even complex models.)
      </p>
      <p className="font-semibold">
        To schedule a demo and test drive Spark, visit{" "}
        <a className="text-brand-light" href="https://coherent.global/" target="_blank" rel="noreferrer">
          coherent.global.
        </a>
      </p>

      <p className="font-semibold">
        To learn more about Agilno visit:{" "}
        <a className="text-brand-light" href="https://agilno.com/" target="_blank" rel="noreferrer">
          agilno.com.
        </a>
      </p>
    </div>
  )
}

